<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="500px"
      :persistent="false"
    >
      <v-form
        ref="form"
      >
        <v-card
          v-if="item"
          :color="getItemColor(item)"
          class="rounded"
          style="padding: 5px 7px 5px 7px;"
          tile
        >
          <v-card-title class="pt-3 pb-7">
            <v-row>
              <v-col>
                <v-row
                  align="center"
                >
                  <v-col class="pt-1 pb-1 pl-1">
                    <v-chip
                      small
                      color="#FFFFFF"
                      text-color="#01579B"
                    >
                      {{ getItemName(item) }}
                    </v-chip>
                  </v-col>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-6 pl-0"
                  >
                    <v-menu offset-y>
                      <template #activator="{ on, attrs }">
                        <v-btn
                          elevation="0"
                          fab
                          color="#FFFFFF"
                          x-small
                          v-bind="attrs"
                          tile
                          style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                          v-on="on"
                        >
                          <v-icon style="color: #01579B;">
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list
                        class="pa-3"
                      >
                        <v-list-item
                          v-if="item.status_id === statusIdInProgress && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                          @click="openEdit(item)"
                        >
                          <v-list-item-title style="color: #1976d2; font-weight: 600;">
                            EDIT
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)) && item.status_id == statusIdInProgress"
                          @click="softDelete(item.id)"
                        >
                          <v-list-item-title style="color: #ff5252; font-weight: 600;">
                            DELETE
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor) || roles.includes(userRoleIdGlassHandler)"
                          @click="openNotes(item.id)"
                        >
                          <v-list-item-title style="color: #ff9800; font-weight: 600;">
                            NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                          </v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="openHistory(item)">
                          <v-list-item-title style="color: #FDD835; font-weight: 600;">
                            HISTORY
                          </v-list-item-title>
                        </v-list-item> -->
                        <v-list-item
                          v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)) && item.status_id == statusIdInProgress"
                          @click="toggle(item.id, item.status_id, true)"
                        >
                          <v-list-item-title style="color: purple; font-weight: 600;">
                            ARCHIVE
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider
                v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
                vertical
                inset
                style="max-height: 30px; margin-top: 15px;"
              />
              <v-col
                cols="auto"
                class="text-end pr-0"
              >
                <v-btn
                  icon
                  @click="dialog = false"
                >
                  <v-icon
                    color="#FFFFFF"
                  >
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text
            style="background-color: #FFFFFF; border-radius: 5px;"
          >
            <v-row
              style="min-height: 41px; border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Class</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <v-chip
                  small
                  :color="item && item.class ? item.class.color : 'grey'"
                  text-color="white"
                >
                  {{ item && item.class ? item.class.name : '' }}
                </v-chip>
              </v-col>
            </v-row>
            <v-row style="min-height: 41px; border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Project</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.project }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Floor</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.project_floor }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">#WO</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.wo_number }}</span>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Screen Qty.</span>
              </v-col>
              <v-col

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.screen_quantity }}</span>
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Stage</span>
              </v-col>
              <v-col
                cols="auto "
                style="line-height: 16px;"
                class="pr-1 pl-1"
              >
                <v-btn
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :ripple="false"
                  color="#FFD84D"
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_cut > 0 ? '#FFD84D' : item.is_assemble == 1 ? '#4CAF50' : ''}; background-color: ${item.total_cut > 0 ? '#FFD84D' : item.is_assemble == 1 ? '#4CAF50' : ''}`"
                  @click="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor)) && item.total_cut > 0 ? openFinishedGoodForm(item, 3): ''"
                >
                  <span
                    v-if="item.total_cut > 0"
                    style="color: #000000;"
                  >{{ item.total_cut }}</span>
                  <span
                    v-else-if="item.is_assemble == 1"
                    style="color: #FFFFFF;"
                  >C</span>
                  <span
                    v-else
                    style="color: #000000;"
                  />
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              style="border-bottom: 1px solid rgba(0,0,0,0.1);"
              align="center"
            >
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Prod.Backlog</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.production_backlog || item.production_backlog == 0"
                  elevation="0"
                  fab
                  outlined
                  tile
                  :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'} ;`"
                >
                  <span
                    style="color: #FFFFFF;"
                  >{{ item.production_backlog || item.production_backlog == 0 ? item.production_backlog : '' }}</span>
                </v-btn>
                <a
                  v-else
                >-</a>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"

                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Ship.Backlog</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <v-btn
                  v-if="item.shipping_backlog || item.shipping_backlog == 0"
                  elevation="0"
                  fab
                  outlined
                  tile
                  readonly
                  :style="`cursor: default; border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'};`"
                >
                  <span
                    style="color: #FFFFFF;"
                  >{{ item.shipping_backlog || item.shipping_backlog == 0 ? item.shipping_backlog : '' }}</span>
                </v-btn>
                <a
                  v-else
                >-</a>
              </v-col>
            </v-row>
            <v-row style="border-bottom: 1px solid rgba(0,0,0,0.1);">
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Panned Ship Date</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: #000000; line-height: 10px;">{{ item.planned_ship_date_short }}</span>
              </v-col>
            </v-row>
            <v-row
              v-if="item.last_note"
              align="center"
            >
              <v-col
                cols="4"
                style="line-height: 16px;"
              >
                <span style="font-size: 16px; color: rgba(0,0,0,0.8)">Note</span>
              </v-col>
              <v-col
                style="line-height: 16px;"
              >
                <span
                  style="color: rgb(255, 152, 0);"
                >
                  <v-btn
                    icon
                    small
                    @click="openNotes(item.id)"
                  >
                    <v-icon
                      small
                      style="color: rgb(255, 152, 0);"
                    >
                      mdi-eye
                    </v-icon>
                  </v-btn></span>
                <span>{{ item.last_note }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <confirm-form ref="confirmForm" />
    <screen-schedule-form
      ref="productionForm"
      @success="get()"
    />
    <screen-schedule-note-form
      ref="noteForm"
      @success="get()"
    />
    <screen-schedule-history-form
      ref="historyForm"
      @success="get()"
    />
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ScreenScheduleForm from '@/components/forms/screenSchedules/ScreenScheduleForm';
import ScreenScheduleNoteForm from '@/components/forms/screenSchedules/ScreenScheduleNoteForm';
import ScreenScheduleHistoryForm from '@/components/forms/screenSchedules/ScreenScheduleHistoryForm';

export default {
  components: {
    ScreenScheduleForm,
    ScreenScheduleNoteForm,
    ScreenScheduleHistoryForm,
  },
  props: {

  },
  data: () => ({
    item: null,
    itemId: null,
    dialog: false,
    statusIdInProgress: 1,
    statusIdComleted: 2,
    noteStatusIdShort: 2,
    materialAvailableId: 1,
    cutId: 2,
    assembleId: 3,
    spandrelId: 4,
    panelsId: 5,
    tAndBId: 6,
    glazedId: 7,
    roles: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdGlassHandler: 13,
    userRoleIdProductionSupervisor: 18,
    userRoleIdSplanderPaintSupervisor: 21,
    userRoleIdProductionAdmin: 22,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.roles = this.user.roles.map((x) => x.id);
  },
  methods: {

    async get() {
      if (!this.itemId) return;
      const submitModel = {
        filters: {
          id: this.itemId,
        },
      };
      const res = await this.$api.screenSchedule.read(submitModel);
      const firstIndex = 0;
      if (!res || !res.data || res.data.length === 0) {
        return;
      }
      this.item = res.data[firstIndex];
    },

    async open(id) {
      this.itemId = id;
      await this.get();
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$emit('success');
    },

    openEdit(item) {
      if (item.job_id) {
        this.$refs.productionForm.open(item.id);
      } else {
        this.$refs.manualForm.open(item.id);
      }
    },

    openNotes(id) {
      this.$refs.noteForm.open(id);
    },

    openHistory(id) {
      this.$refs.historyForm.open(id);
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.screenSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async toggle(id, statusId) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${statusId === this.statusIdInProgress ? 'COMPLETE' : 'RESTORE'}?`,
      });
      if (!confirm) return;
      const res = await this.$api.screenSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.close();
    },

    getItemColor(item) {
      if (item.is_glaze === 1 && item.total_glaze === 0) {
        return '#0BDE79';
      }
      return '#1870CB';
    },

    getItemName(item) {
      if (item.is_glaze === 1 && item.total_glaze === 0) {
        return 'COMPLETE';
      }
      return 'CUT';
    },

    getFontColor(item) {
      if (item.is_glaze === 1 && item.total_glaze === 0) {
        return '#000';
      }
      return '#FFF';
    },
  },
};
</script>

<style scoped>
.box
{
  border-radius: 4px;
   width: 25px;
    height: 25px;
}

.empty-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFFFFF;
}

.red-box
{
  border: 1.5px solid #F44336;
  background-color: #F44336;
}

.yellow-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFD84D;
}

.green-box
{
  border: 1.5px solid #4CAF50;
  background-color: #4CAF50;
}
</style>
